import {
    AppBar,
    Container,
    Dialog,
    IconButton,
    Toolbar,
    Typography,
} from "@mui/material";
import RegulationsContainer from "./RegulationsContainer";
import CloseIcon from "@mui/icons-material/Close";

export default function RegulationsDialog({ onClose = () => {} }) {
    return (
        <Dialog open={true} fullScreen>
            <AppBar>
                <Toolbar
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Typography fontSize="1.1rem" fontWeight="bold">
                        قوانین دوره
                    </Typography>

                    <IconButton onClick={onClose}>
                        <CloseIcon sx={{ fill: "#fff" }} />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <Container sx={{ mt: "80px", mb: "40px" }}>
                <RegulationsContainer displayButton onButtonClick={onClose} />
            </Container>
        </Dialog>
    );
}
